import React, { useEffect, useRef, useState } from "react";
import styles from "../addCategoryForm/addCategoryForm.module.css";
import { Close, Closecircle, closeCircle, UploadImg } from "../../Svg";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import VariantsCard from "./VariantsCard";
import PricingCard from "./PricingCard";
import MediaCard from "./MediaCard";
import RichTextEditor from "./RichTextEditor";
import { addProductThunk, updateProductThunk } from "../../redux/productSlice";
import { stripHtmlTags } from "../../utils/fomateDate";
import axios from "axios";
import { Upload } from "@mui/icons-material";
import SearchableSelect from "../reusable/SearchableSelect";


const status = ['OUT OF STOCK', 'PUBLISHED', 'DRAFT']
const AddProductForm = ({ productDetails, from, id, loadings }) => {
    const thumbnailImageref = useRef();
    const dataSheetRef = useRef();
    const [loading, setLoading] = useState(false);
    const [dataUrlLoading, setdataUrlLoading] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [isCoverUploadloading, setCoverUploading] = useState(false);
    const [featuredUrlInput, setFeaturedUrlInput] = useState("");
    const [datasheetUrlInput, setDatasheetUrlInput] = useState("");
    const { exportedData } = useSelector((state) => state.manufacturer);


    const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
    const categories = categoryHeirarchy?.categories || [];
    const subcategory = categoryHeirarchy?.subcategories || [];
    const level3 = categoryHeirarchy?.level3categories || []
    const manufacturer = Array.isArray(exportedData) ? exportedData : (Array.isArray(exportedData?.data) ? exportedData.data : []);

    const combinedManufacturers = React.useMemo(() => {
        const list = Array.isArray(manufacturer) ? [...manufacturer] : [];
        const rawMfg = productDetails?.productOverview?.manufacturer;
        const first = Array.isArray(rawMfg) ? rawMfg[0] : rawMfg;
        const mfgId = (first?._id || (typeof first === 'string' ? first : ''))?.toString();
        const mfgNameFromAttrs = productDetails?.attributes?.Manufacturer?.[0]
            || productDetails?.attributes?.manufacturer?.[0]
            || Object.entries(productDetails?.attributes || {}).find(([k]) => k.trim().toLowerCase() === 'manufacturer')?.[1]?.[0];
        const mfgName = (first?.name || mfgNameFromAttrs || '').toString().trim();

        if (mfgId || mfgName) {
            const alreadyInList = list.some(m => 
                (mfgId && (m?._id?.toString() === mfgId || m?.id?.toString() === mfgId)) ||
                (mfgName && m?.name?.trim()?.toLowerCase() === mfgName.toLowerCase())
            );
            if (!alreadyInList) {
                list.unshift({
                    _id: mfgId || mfgName,
                    name: mfgName || 'Manufacturer'
                });
            }
        }
        return list;
    }, [manufacturer, productDetails]);

    const [filteredSubcategory, setFiilteredSubcategory] = useState([]);
    const [filteredLevel3, setFilteredLevel3] = useState([])
    const { productsdrop } = useSelector((state) => state.products);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch()



    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState(null);


    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setIsOpen(false);
        setSearchTerm('');
        setFilteredData(null);
    };

    const handleToggleDropdown = () => {
        const newState = !isOpen;
        setIsOpen(newState);
        if (!newState) {
            closeDropdown();
        }
    };

    const handleSearchChange = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        const filtered = term === ''
            ? null
            : productsdrop?.filter(customer =>
                customer?.productNumber?.toLowerCase().includes(term.toLowerCase())
            );
        setFilteredData(filtered);
    };


    const getInitialCategories = () => {
        if (!productDetails?.categories || productDetails.categories.length === 0) {
            return ["", "", ""];
        }
        
        let catLvl1 = productDetails.categories.find(c => {
            const id = c?._id || c;
            return categories.some(x => x._id?.toString() === id?.toString());
        });
        
        let catLvl2 = productDetails.categories.find(c => {
            const id = c?._id || c;
            return subcategory.some(x => x._id?.toString() === id?.toString());
        });
        
        let catLvl3 = productDetails.categories.find(c => {
            const id = c?._id || c;
            return level3.some(x => x._id?.toString() === id?.toString());
        });

        // Get initial IDs from productDetails
        let lvl3Id = catLvl3?._id || (typeof catLvl3 === 'string' ? catLvl3 : "");
        let lvl2Id = catLvl2?._id || (typeof catLvl2 === 'string' ? catLvl2 : "");
        let lvl1Id = catLvl1?._id || (typeof catLvl1 === 'string' ? catLvl1 : "");

        // 1. Trace UP if Level 3 is present
        if (lvl3Id) {
            if (!lvl2Id) {
                const selectedLvl3 = level3.find(x => x._id?.toString() === lvl3Id.toString());
                if (selectedLvl3) {
                    const parentSubId = Array.isArray(selectedLvl3.parentId)
                        ? selectedLvl3.parentId[0]
                        : selectedLvl3.parentId;
                    if (parentSubId) lvl2Id = parentSubId.toString();
                }
            }
        }

        // 2. Trace UP if Sub-Category is present
        if (lvl2Id) {
            if (!lvl1Id) {
                const selectedSub = subcategory.find(x => x._id?.toString() === lvl2Id.toString());
                if (selectedSub) {
                    const parentCatId = Array.isArray(selectedSub.parentId)
                        ? selectedSub.parentId[0]
                        : selectedSub.parentId;
                    if (parentCatId) lvl1Id = parentCatId.toString();
                }
            }
        }

        // 3. Trace DOWN if Category is present but Sub-Category is missing
        if (lvl1Id && !lvl2Id) {
            const defaultSub = subcategory.find(x => {
                const p = x.parentId;
                return Array.isArray(p)
                    ? p.some(val => val?.toString() === lvl1Id.toString())
                    : p?.toString() === lvl1Id.toString();
            });
            if (defaultSub) lvl2Id = defaultSub._id?.toString();
        }

        // 4. Trace DOWN if Sub-Category is present but Level 3 is missing
        if (lvl2Id && !lvl3Id) {
            const defaultLvl3 = level3.find(x => {
                const p = x.parentId;
                return Array.isArray(p)
                    ? p.some(val => val?.toString() === lvl2Id.toString())
                    : p?.toString() === lvl2Id.toString();
            });
            if (defaultLvl3) lvl3Id = defaultLvl3._id?.toString();
        }

        return [
            lvl1Id,
            lvl2Id,
            lvl3Id
        ];
    };

    const getInitialManufacturer = () => {
        const allMfgs = combinedManufacturers?.length ? combinedManufacturers : (manufacturer || []);
        const rawMfg = productDetails?.productOverview?.manufacturer;
        let mfgId = "";
        let mfgName = "";

        if (Array.isArray(rawMfg) && rawMfg.length > 0) {
            const first = rawMfg[0];
            if (first && typeof first === "object") {
                mfgId = (first._id || first.id || "")?.toString();
                mfgName = (first.name || "")?.toString().trim();
            } else if (typeof first === "string") {
                mfgId = first;
            }
        } else if (rawMfg && typeof rawMfg === "object") {
            mfgId = (rawMfg._id || rawMfg.id || "")?.toString();
            mfgName = (rawMfg.name || "")?.toString().trim();
        } else if (typeof rawMfg === "string" && rawMfg) {
            mfgId = rawMfg;
        }

        // Fallback: match from productDetails.attributes.Manufacturer
        if (!mfgName && productDetails?.attributes) {
            const mfgAttrKey = Object.keys(productDetails.attributes).find(
                k => k.trim().toLowerCase() === "manufacturer"
            );
            if (mfgAttrKey && productDetails.attributes[mfgAttrKey]) {
                const attrVal = Array.isArray(productDetails.attributes[mfgAttrKey])
                    ? productDetails.attributes[mfgAttrKey][0]
                    : productDetails.attributes[mfgAttrKey];
                if (attrVal) {
                    mfgName = String(attrVal).trim();
                }
            }
        }

        if (mfgId && allMfgs.length) {
            const matchedById = allMfgs.find(m => (m?._id || m?.id)?.toString() === mfgId);
            if (matchedById) return [matchedById._id?.toString() || mfgId];
        }
        if (mfgName && allMfgs.length) {
            const matchedByName = allMfgs.find(m => m?.name?.trim()?.toLowerCase() === mfgName.toLowerCase());
            if (matchedByName) return [(matchedByName._id || matchedByName.id)?.toString()];
        }

        return [mfgId || mfgName || ""];
    };

    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        handleBlur,
        handleSubmit,
        resetForm,
    } = useFormik({
        enableReinitialize: true,
        initialValues: {
            productOverview: {
                ElectrowizCode: productDetails?.productOverview?.ElectrowizCode || [""],
                productNumber: productDetails?.productOverview?.productNumber || [""],
                description: productDetails?.productOverview?.description || [""],
                datasheetUrl: productDetails?.productOverview?.datasheetUrl || [""],
                manufacturer: getInitialManufacturer(),
                manufactureLeadTime: productDetails?.productOverview?.manufactureLeadTime || [""],

            },
            attributes: productDetails?.attributes || {},
            RoHS: productDetails?.RoHS?.length ? (Array.isArray(productDetails.RoHS) ? productDetails.RoHS : [productDetails.RoHS]) : ["YES"],
            additionalResources: productDetails?.additionalResources || {
                "HSN Code": [''],
                Standard_Packaging_Quantity: ['']
            },
            categories: getInitialCategories(),
            alternateProducts: productDetails?.alternateProducts || [],
            quantityTable: productDetails?.quantityTable || [
                {
                    breakQty: "",
                    productNumber: "",
                    fee: "",
                    isDiscount: false,
                    minMultiplier: "",
                    packaging: "",
                    unitPrice: "",
                    finalPrice: ""
                },
            ],
            inventory: {
                sku: productDetails?.inventory?.sku || "",
                qtyAvailable: productDetails?.inventory?.qtyAvailable || 0,
                minimumMultiplier: productDetails?.inventory?.minimumMultiplier || 1,
                shortLeadTime: productDetails?.inventory?.shortLeadTime || null
            },
            assets: {
                image: productDetails?.assets?.image || [],
                video: productDetails?.assets?.video || [],
                featuredImage: productDetails?.assets?.featuredImage || []
            },
            gst: productDetails?.gst ?? "",
            status: productDetails?.status || "PUBLISHED",
            activestatus: "ACTIVE"
        },

        validationSchema: from === "add" ? Yup.object({
            productOverview: Yup.object({
                productNumber: Yup.array().of(Yup.string().required("Product number is required")),
                manufacturer: Yup.array().of(Yup.string().required("manufacturer is required")),
                manufactureLeadTime: Yup.array().of(Yup.string().required("manufactureLeadTime is required")),
            }),
            attributes: Yup.object().test(
                "at-least-one-attribute",
                "At least one attribute must be added",
                (value) => Object.keys(value).length > 0
            ),

            quantityTable: Yup.array()
                .of(
                    Yup.object().shape({
                        breakQty: Yup.number()
                            .typeError("breakQty must be a number")
                            .required("Break Quantity is required"),
                        unitPrice: Yup.number()
                            .typeError("unitPrice must be a number")
                            .required("Unit Price is required"),
                        finalPrice: Yup.number()
                            .typeError("finalPrice must be a number")
                            .required("Final Price is required"),
                    })
                )
                .min(1, "At least one quantity entry is required"),

            inventory: Yup.object().shape({
                sku: Yup.string().required('sku is required'),
                qtyAvailable: Yup.string().required('qtyAvailable is required'),
                minimumMultiplier: Yup.string().required('minimumMultiplier is required')
            }),
            categories: Yup.array()
                .of(Yup.string()) // Ensuring array contains strings
                .test("category-selected", "Category not selected", (value) => !!value?.[0]) // Validate categories[0]
                .test("subcategory-selected", "Subcategory not selected", (value) => !!value?.[1]), // Validate categories[1]
            gst: Yup.string().required("GST is required"),
            status: Yup.string().required('status  is required'),
        }) : Yup.object(),

        enableReinitialize: true,
        onSubmit: async (values) => {
            setFormLoading(true)

            try {
                const toArray = (value) => Array.isArray(value)
                    ? value
                    : value === undefined || value === null || value === "" ? [] : [value];
                const gstNum = values.gst === "" || values.gst === null || values.gst === undefined
                    ? (productDetails?.gst ?? 18)
                    : Number(values.gst);

                // Preserve legacy product data while sending only valid IDs/values to the API.
                const quantityTable = (values.quantityTable || []).map((item) => ({
                    ...item,
                    unitPrice: item.unitPrice === "" || item.unitPrice == null ? null : Number(item.unitPrice),
                    finalPrice: item.finalPrice === "" || item.finalPrice == null ? null : Number(item.finalPrice),
                }));
                const productOverview = values.productOverview || {};
                const payloadValues = {
                    ...values,
                    productOverview: {
                        ...productOverview,
                        manufacturer: toArray(productOverview.manufacturer)
                            .map((item) => item?._id || item?.id || item)
                            .filter(Boolean),
                        description: toArray(productOverview.description).map((desc) => stripHtmlTags(desc)),
                    },
                    categories: toArray(values.categories)
                        .map((item) => item?._id || item?.id || item)
                        .filter(Boolean),
                    gst: gstNum,
                    quantityTable,
                };

                const data = {
                    id,
                    values: payloadValues
                }

                const status = from == "add" ? await dispatch(addProductThunk(payloadValues)) : await dispatch(updateProductThunk(data))
                if (status?.payload == 200) {
                    navigate(from === "edit" ? "/products/allProduct" : -1, { replace: from === "edit" })
                }
            } catch (error) {
                console.error("Unable to save product", error);
                toast.error("Unable to save product. Please try again.");
            } finally {
                setFormLoading(false)
            }

        },
    });

    // console.log(errors);
    console.log(values)

    const handleImageChange = async (e, attribute, repo) => {
        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        if (repo == "photo") {
            setLoading(true);
        } else {
            setCoverUploading(true);
        }

        try {
            if (file) {
                const body = new FormData();
                body.append("image", file);
                body.append("repo", `category/${repo}`);

                const { data, status } = await api.fileUpload(body);

                if (status === 200) {
                    setFieldValue(attribute, data.data[0]);
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file");
        } finally {
            if (repo == "photo") {
                setLoading(false);
            } else {
                setCoverUploading(false);
            }
        }
    };


    // -----------------------------------------------------------------------
    // buildAttributesFromCategory - MUST be defined before handleCategoryChange
    // -----------------------------------------------------------------------
    const buildAttributesFromCategory = (catsArr) => {
        const selectedIds = (catsArr || []).filter(Boolean).map(id => id.toString());
        if (selectedIds.length === 0) return null;

        const newAttrsObj = {};

        // Step 1: Get attribute type names from the category's atributes array
        const matchedLevel3 = level3?.find(c => c?._id?.toString() === catsArr[2]?.toString());
        const matchedSub = subcategory?.find(c => c?._id?.toString() === catsArr[1]?.toString());
        const matchedCat = categories?.find(c => c?._id?.toString() === catsArr[0]?.toString());
        const activeCatObj = matchedLevel3 || matchedSub || matchedCat;

        const selectedMfgId = values?.productOverview?.manufacturer?.[0];
        const selectedMfg = manufacturer?.find(m => m?._id?.toString() === selectedMfgId?.toString());
        const currentMfgName = selectedMfg?.name;

        const existingAttrs = (from === 'edit' && productDetails?.attributes && Object.keys(productDetails.attributes).length > 0)
            ? { ...productDetails.attributes, ...(values?.attributes || {}) }
            : (values?.attributes || {});

        // Attributes ticked for this level 3 in the admin: when set, only these rows are shown
        const chosenAttributes = Array.isArray(matchedLevel3?.displayAttributes)
            ? matchedLevel3.displayAttributes.filter(name => name && String(name).trim() !== '')
            : [];
        if (chosenAttributes.length > 0) {
            chosenAttributes.forEach(attrName => {
                if (attrName.trim().toLowerCase() === "manufacturer" && currentMfgName) {
                    newAttrsObj[attrName] = [currentMfgName];
                } else if (existingAttrs[attrName] !== undefined && existingAttrs[attrName] !== null) {
                    const val = existingAttrs[attrName];
                    newAttrsObj[attrName] = Array.isArray(val) ? val : (val !== "" ? [String(val)] : []);
                } else {
                    newAttrsObj[attrName] = [];
                }
            });
            // When editing, keep the attributes this product already has saved
            if (from === 'edit' && productDetails?.attributes) {
                Object.entries(productDetails.attributes).forEach(([k, v]) => {
                    if (k && !(k in newAttrsObj)) {
                        newAttrsObj[k] = Array.isArray(v) ? v : (v !== undefined && v !== null && v !== "" ? [String(v)] : []);
                    }
                });
            }
            return newAttrsObj;
        }

        if (activeCatObj && Array.isArray(activeCatObj.atributes)) {
            activeCatObj.atributes.forEach(attr => {
                const attrName = typeof attr === 'string' ? attr : (attr?.type || attr?.name || '');
                if (attrName && attrName.trim() !== '') {
                    if (attrName.trim().toLowerCase() === "manufacturer" && currentMfgName) {
                        newAttrsObj[attrName] = [currentMfgName];
                    } else if (existingAttrs[attrName] !== undefined && existingAttrs[attrName] !== null) {
                        const val = existingAttrs[attrName];
                        newAttrsObj[attrName] = Array.isArray(val) ? val : (val !== "" ? [String(val)] : []);
                    } else {
                        newAttrsObj[attrName] = []; // Empty value - user fills manually
                    }
                }
            });
        }

        // Preserve any existing attribute keys that were already present on product
        Object.entries(existingAttrs).forEach(([k, v]) => {
            if (k && !(k in newAttrsObj)) {
                newAttrsObj[k] = Array.isArray(v) ? v : (v !== undefined && v !== null && v !== "" ? [String(v)] : []);
            }
        });

        // Step 2: Get attribute type names from existing products in same category
        // (only add type keys, NOT values - user fills values manually)
        const matchingProducts = (productsdrop || []).filter(p => {
            const pCats = (p.categories || []).map(c => (c?._id || c)?.toString());
            return selectedIds.some(id => pCats.includes(id));
        });

        matchingProducts.forEach(p => {
            const pAttrs = p.attributes;
            if (!pAttrs || typeof pAttrs !== 'object') return;
            Object.keys(pAttrs).forEach(attrKey => {
                if (attrKey && attrKey.trim() !== '' && !(attrKey in newAttrsObj)) {
                    newAttrsObj[attrKey] = []; // Add type key only, empty value
                }
            });
        });

        if (Object.keys(newAttrsObj).length === 0) return null;
        return newAttrsObj;
    };

    const getHsnForLevel3 = (targetLvl3Id, selectedLvl3Obj) => {
        const fromLvl3 = selectedLvl3Obj?.hsnCode || selectedLvl3Obj?.hsn || selectedLvl3Obj?.hsn_code || selectedLvl3Obj?.['HSN Code'] || selectedLvl3Obj?.hsnNumber;
        if (fromLvl3) return typeof fromLvl3 === 'string' ? fromLvl3 : (Array.isArray(fromLvl3) ? fromLvl3[0] : String(fromLvl3));

        if (productsdrop && productsdrop.length > 0) {
            if (targetLvl3Id) {
                const match = productsdrop.find(p => {
                    const pCats = (p.categories || []).map(c => (c?._id || c)?.toString());
                    if (!pCats.includes(targetLvl3Id.toString())) return false;
                    const res = p.additionalResources;
                    if (!res) return false;
                    const val = res["HSN Code"]?.[0] || res["HSN Code"] || res.hsnCode || res.hsn;
                    return Boolean(val);
                });
                if (match && match.additionalResources) {
                    const res = match.additionalResources;
                    const val = res["HSN Code"]?.[0] || res["HSN Code"] || res.hsnCode || res.hsn;
                    if (val) return typeof val === 'string' ? val : (Array.isArray(val) ? val[0] : String(val));
                }
            }

            const anyMatch = productsdrop.find(p => {
                const res = p.additionalResources;
                if (!res) return false;
                const val = res["HSN Code"]?.[0] || res["HSN Code"] || res.hsnCode || res.hsn;
                return Boolean(val);
            });
            if (anyMatch && anyMatch.additionalResources) {
                const res = anyMatch.additionalResources;
                const val = res["HSN Code"]?.[0] || res["HSN Code"] || res.hsnCode || res.hsn;
                if (val) return typeof val === 'string' ? val : (Array.isArray(val) ? val[0] : String(val));
            }
        }

        return "85423900";
    };

    const handleCategoryChange = (e) => {
        const { name, value } = e.target;
        handleChange(e);

        let targetLvl3Id = values.categories?.[2];
        if (name === "categories[2]") {
            targetLvl3Id = value;
        }

        if (name === "categories[2]" && value) {
            const selectedLvl3 = level3?.find((item) => item?._id === value);
            if (selectedLvl3) {
                const parentSubId = Array.isArray(selectedLvl3.parentId)
                    ? selectedLvl3.parentId[0]
                    : selectedLvl3.parentId;

                if (parentSubId) {
                    setFieldValue("categories[1]", parentSubId);
                    const selectedSub = subcategory?.find((item) => item?._id === parentSubId);
                    if (selectedSub) {
                        const parentCatId = Array.isArray(selectedSub.parentId)
                            ? selectedSub.parentId[0]
                            : selectedSub.parentId;
                        if (parentCatId) {
                            setFieldValue("categories[0]", parentCatId);
                        }
                    }
                }
            }

            // Automatically set GST to 18% (or selectedLvl3.gst if defined)
            setFieldValue("gst", selectedLvl3?.gst !== undefined && selectedLvl3?.gst !== null && selectedLvl3?.gst !== "" ? selectedLvl3.gst : 18);

            // Automatically pull HSN Code
            const hsnToSet = getHsnForLevel3(value, selectedLvl3);
            setFieldValue("additionalResources.HSN Code[0]", hsnToSet);
        } else if (name === "categories[1]" && value) {
            const selectedSub = subcategory?.find((item) => item?._id === value);
            if (selectedSub) {
                const parentCatId = Array.isArray(selectedSub.parentId)
                    ? selectedSub.parentId[0]
                    : selectedSub.parentId;
                if (parentCatId) {
                    setFieldValue("categories[0]", parentCatId);
                }
            }
        } else if (name === "categories[0]" && !value) {
            setFieldValue("categories[1]", "");
            setFieldValue("categories[2]", "");
        }

        // Build updatedCatArr with the NEW value already included
        const updatedCatArr = [
            name === "categories[0]" ? value : values.categories?.[0],
            name === "categories[1]" ? value : values.categories?.[1],
            name === "categories[2]" ? value : targetLvl3Id,
        ];

        const builtAttrs = buildAttributesFromCategory(updatedCatArr);
        if (builtAttrs && Object.keys(builtAttrs).length > 0) {
            setFieldValue("attributes", builtAttrs);
        }
    };

    useEffect(() => {
        if (values?.categories?.[0]) {
            if (subcategory?.length > 0) {
                const filteredSub = subcategory?.filter((i) => {
                    const parent = i?.parentId;
                    if (Array.isArray(parent)) {
                        return parent.some(p => p?.toString() === values?.categories[0]?.toString());
                    }
                    return parent?.toString() === values?.categories[0]?.toString();
                });
                setFiilteredSubcategory(filteredSub?.length > 0 ? filteredSub : subcategory);
            } else {
                setFiilteredSubcategory(subcategory);
            }
        } else {
            setFiilteredSubcategory(subcategory);
        }

        if (values?.categories?.[1]) {
            if (level3?.length > 0) {
                const filteredLvl3 = level3?.filter((i) => {
                    const parent = i?.parentId;
                    if (Array.isArray(parent)) {
                        return parent.some(p => p?.toString() === values?.categories[1]?.toString());
                    }
                    return parent?.toString() === values?.categories[1]?.toString();
                });
                setFilteredLevel3(filteredLvl3?.length > 0 ? filteredLvl3 : level3);
            } else {
                setFilteredLevel3(level3);
            }
        } else {
            setFilteredLevel3(level3);
        }
    }, [values.categories, subcategory, level3]);

    // When categories change (including after data loads), auto-fill attributes, GST, and HSN
    useEffect(() => {
        const hasCategory = values?.categories?.some(Boolean);
        if (!hasCategory) return;

        // In edit mode with existing attributes, do NOT wipe out existing attributes!
        if (from === "edit" && productDetails?.attributes && Object.keys(productDetails.attributes).length > 0) {
            if (!values.attributes || Object.keys(values.attributes).length === 0) {
                setFieldValue("attributes", productDetails.attributes);
            }
        } else {
            const builtAttrs = buildAttributesFromCategory(values.categories);
            if (builtAttrs && Object.keys(builtAttrs).length > 0) {
                setFieldValue("attributes", builtAttrs);
            }
        }

        if (values?.categories?.[2]) {
            const selectedLvl3 = level3?.find((item) => item?._id === values.categories[2]);
            if (values.gst === "" || values.gst === undefined || values.gst === null) {
                setFieldValue("gst", selectedLvl3?.gst !== undefined && selectedLvl3?.gst !== null && selectedLvl3?.gst !== "" ? selectedLvl3.gst : 18);
            }
            const currentHsn = values.additionalResources?.["HSN Code"]?.[0];
            if (!currentHsn) {
                const hsnToSet = getHsnForLevel3(values.categories[2], selectedLvl3);
                setFieldValue("additionalResources.HSN Code[0]", hsnToSet);
            }
        }
    }, [values.categories?.[2], values.categories?.[1], values.categories?.[0], level3, subcategory, categories, productsdrop]);

    // Auto-populate Manufacturer in form and attributes whenever manufacturer data or selection changes
    useEffect(() => {
        const allMfgs = combinedManufacturers?.length ? combinedManufacturers : (manufacturer || []);
        if (!allMfgs || allMfgs.length === 0) return;
        const currentMfgId = values?.productOverview?.manufacturer?.[0];

        // If not selected or current ID is empty/not in manufacturer options, try to resolve it
        const isMatched = currentMfgId && allMfgs.some(m => 
            (m?._id || m?.id)?.toString() === currentMfgId?.toString() ||
            m?.name?.trim()?.toLowerCase() === currentMfgId?.toString()?.toLowerCase()
        );

        if (!isMatched) {
            let resolvedId = "";
            const rawMfg = productDetails?.productOverview?.manufacturer;
            if (Array.isArray(rawMfg) && rawMfg.length > 0) {
                const first = rawMfg[0];
                const candId = (first?._id || (typeof first === "string" ? first : ""))?.toString();
                if (candId && allMfgs.some(m => (m?._id || m?.id)?.toString() === candId)) {
                    resolvedId = candId;
                } else if (first?.name) {
                    const matched = allMfgs.find(m => m?.name?.trim()?.toLowerCase() === first.name.trim().toLowerCase());
                    if (matched) resolvedId = (matched._id || matched.id)?.toString();
                }
            }
            if (!resolvedId) {
                const attrs = values?.attributes || productDetails?.attributes || {};
                const mfgKey = Object.keys(attrs).find(k => k.trim().toLowerCase() === "manufacturer");
                if (mfgKey && attrs[mfgKey]) {
                    const attrVal = Array.isArray(attrs[mfgKey]) ? attrs[mfgKey][0] : attrs[mfgKey];
                    if (attrVal) {
                        const matched = allMfgs.find(m => m?.name?.trim()?.toLowerCase() === String(attrVal).trim().toLowerCase());
                        if (matched) resolvedId = (matched._id || matched.id)?.toString();
                        else resolvedId = String(attrVal).trim();
                    }
                }
            }
            if (resolvedId && resolvedId !== currentMfgId) {
                setFieldValue("productOverview.manufacturer[0]", resolvedId);
            }
        } else {
            // Manufacturer is selected, sync brand name to attributes
            const selectedMfg = allMfgs.find(m => 
                (m?._id || m?.id)?.toString() === currentMfgId?.toString() ||
                m?.name?.trim()?.toLowerCase() === currentMfgId?.toString()?.toLowerCase()
            );
            const mfgName = selectedMfg?.name;
            if (mfgName && values.attributes && typeof values.attributes === 'object') {
                const mfgKey = Object.keys(values.attributes).find(k => k.trim().toLowerCase() === "manufacturer");
                if (mfgKey) {
                    const currentVal = Array.isArray(values.attributes[mfgKey]) ? values.attributes[mfgKey][0] : values.attributes[mfgKey];
                    if (!currentVal || currentVal.trim() === "" || currentVal !== mfgName) {
                        const currentAttrs = { ...values.attributes };
                        currentAttrs[mfgKey] = [mfgName];
                        setFieldValue("attributes", currentAttrs);
                    }
                }
            }
        }
    }, [values.productOverview?.manufacturer?.[0], combinedManufacturers, manufacturer, productDetails]);

    const handleRemove = (repo) => {
        setFieldValue(repo, "");
    };

    const handleAddFeaturedUrl = () => {
        if (!featuredUrlInput || !featuredUrlInput.trim()) return;
        setFieldValue("assets.featuredImage[0]", featuredUrlInput.trim());
        setFeaturedUrlInput("");
    };




    // Handle selection change (Add or remove manufacturer)
    const handleSelectionChange = (manufacturerId) => {
        const { alternateProducts } = values;
        if (alternateProducts?.includes(manufacturerId)) {
            setFieldValue(
                "alternateProducts",
                alternateProducts?.filter(id => id !== manufacturerId)
            );
        } else {
            setFieldValue(
                "alternateProducts",
                [...alternateProducts, manufacturerId]
            );
        }
    };



    // Handle Data Sheet File Upload
    const handleFileUpload = async (e) => {
        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        if (!file) return;
        try {
            setdataUrlLoading(true);
            const body = {
                key: `${Date.now()}_${file.name}`,
                fileType: file.type || "application/pdf",
                fileName: file.name,
            };

            const { data, status } = await api.getPutSignedUrl(body);

            if (status === 200) {
                await axios.put(data.data?.preSigned, file, {
                    headers: {
                        'Content-Type': file.type || "application/pdf",
                    },
                });
                setFieldValue('productOverview.datasheetUrl', [data?.data?.url]);
                toast.success('Data sheet uploaded successfully');
            }
        } catch (err) {
            console.error(err);
            toast.error('Error uploading file');
        } finally {
            setdataUrlLoading(false);
            if (dataSheetRef.current) {
                dataSheetRef.current.value = "";
            }
        }
    };

    const handleAddDatasheetUrl = () => {
        if (!datasheetUrlInput || !datasheetUrlInput.trim()) return;
        setFieldValue("productOverview.datasheetUrl", [datasheetUrlInput.trim()]);
        setDatasheetUrlInput("");
    };


    if (loadings) {
        return (
            <div>
                Loading...
            </div>
        )
    }

    return (
        <>
            <form onSubmit={handleSubmit} className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>General Information</h2>
                        <label className={styles.addCatLabel}>
                            Product Name
                            <input
                                type="text"
                                name="productOverview.productNumber[0]"
                                placeholder="Type product name here. . ."
                                className={styles.addCatInput}
                                value={values.productOverview.productNumber[0]}
                                onChange={(e) => {
                                    handleChange(e);
                                    const val = e.target.value?.trim();
                                    if (val && productsdrop?.length) {
                                        const matched = productsdrop.find((p) => {
                                            const num = Array.isArray(p.productOverview?.productNumber)
                                                ? p.productOverview.productNumber[0]
                                                : (p.productOverview?.productNumber || p.productNumber || p.sku);
                                            return num && num.toString().toLowerCase() === val.toLowerCase();
                                        });
                                        if (matched && matched.attributes && typeof matched.attributes === 'object') {
                                            const mergedAttrs = { ...(values.attributes || {}) };
                                            Object.entries(matched.attributes).forEach(([attrKey, attrVal]) => {
                                                if (attrKey) {
                                                    let valArr = Array.isArray(attrVal) ? attrVal : [attrVal];
                                                    mergedAttrs[attrKey] = valArr;
                                                }
                                            });
                                            setFieldValue("attributes", mergedAttrs);
                                        }
                                    }
                                }}
                                onBlur={handleBlur}
                            />
                            {errors.productOverview?.productNumber?.[0] && touched.productOverview?.productNumber?.[0] && (
                                <p className={styles.errorText}>{errors.productOverview?.productNumber[0]}</p>
                            )}

                        </label>



                        <label
                            className={styles.addCatLabel}
                            style={{ paddingBottom: "8px" }}
                        >
                            Description
                        </label>



                        <RichTextEditor
                            // value={values?.productOverview?.description || [""]} 
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                        // onBlur={handleBlur}
                        />


                        <div className={styles.imageUpload}>
                            <p className={styles.addCatLabel} style={{ marginBottom: "4px" }}>Data Sheet</p>
                            {dataUrlLoading ? (
                                <div className={styles.uploadBox} style={{ padding: "12px" }}>
                                    please wait...
                                </div>
                            ) : (
                                <>
                                    {Boolean(
                                        (Array.isArray(values?.productOverview?.datasheetUrl)
                                            ? values?.productOverview?.datasheetUrl?.[0]
                                            : values?.productOverview?.datasheetUrl)?.trim()
                                    ) ? (
                                        <div
                                            className={styles.uploadBox}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                padding: "12px 16px",
                                                background: "#f8f9fa",
                                            }}
                                        >
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px", overflow: "hidden" }}>
                                                <span className={styles.uploadIcon} style={{ margin: 0, fontSize: "1.5rem", color: "#512DA8", display: "flex", alignItems: "center" }}>
                                                    <UploadImg />
                                                </span>
                                                <a
                                                    href={
                                                        Array.isArray(values?.productOverview?.datasheetUrl)
                                                            ? values?.productOverview?.datasheetUrl?.[0]
                                                            : values?.productOverview?.datasheetUrl
                                                    }
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{
                                                        color: "#512DA8",
                                                        textDecoration: "underline",
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        maxWidth: "400px"
                                                    }}
                                                    title={
                                                        Array.isArray(values?.productOverview?.datasheetUrl)
                                                            ? values?.productOverview?.datasheetUrl?.[0]
                                                            : values?.productOverview?.datasheetUrl
                                                    }
                                                >
                                                    {(() => {
                                                        const url = Array.isArray(values?.productOverview?.datasheetUrl)
                                                            ? values?.productOverview?.datasheetUrl?.[0]
                                                            : values?.productOverview?.datasheetUrl;
                                                        return url?.split("/").pop() || url;
                                                    })()}
                                                </a>
                                            </div>
                                            <div
                                                className={styles.cancel_cross}
                                                style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                                onClick={() => setFieldValue("productOverview.datasheetUrl", [""])}
                                                title="Remove datasheet"
                                            >
                                                {closeCircle()}
                                            </div>
                                        </div>
                                    ) : (
                                        <div
                                            className={styles.uploadBox}
                                            onClick={() => dataSheetRef.current && dataSheetRef.current.click()}
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                handleFileUpload(e);
                                            }}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{ cursor: 'pointer', padding: "14px 16px" }}
                                        >
                                            <span className={styles.uploadIcon} style={{ marginBottom: "4px" }}>
                                                <UploadImg />
                                            </span>
                                            <p className={styles.addCatPara} style={{ fontSize: "13px", marginBottom: "8px" }}>
                                                Drag and drop file here, or click to add datasheet
                                            </p>
                                            <button type="button" className={styles.addImgBtn} style={{ padding: "6px 14px", fontSize: "13px" }}>
                                                Choose File
                                            </button>
                                            <input
                                                type="file"
                                                style={{ display: 'none' }}
                                                ref={dataSheetRef}
                                                onChange={handleFileUpload}
                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,application/pdf"
                                            />
                                        </div>
                                    )}

                                    <div className={styles.urlInputContainer} style={{ marginTop: "8px" }}>
                                        <input
                                            type="text"
                                            placeholder="Enter datasheet URL"
                                            className={styles.urlInput}
                                            value={datasheetUrlInput}
                                            onChange={(e) => setDatasheetUrlInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleAddDatasheetUrl();
                                                }
                                            }}
                                        />
                                        <button type="button" className={styles.urlAddBtn} onClick={handleAddDatasheetUrl}>
                                            Add URL
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>

                        <label className={styles.addCatLabel}>
                            manufactureLeadTime
                            <input
                                type="text"
                                name="productOverview.manufactureLeadTime[0]"
                                placeholder="Enter"
                                className={styles.addCatInput}
                                value={values.productOverview?.manufactureLeadTime[0]}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {errors.productOverview?.manufactureLeadTime?.[0] && touched.productOverview?.manufactureLeadTime?.[0] && (
                                <p className={styles.errorText}>{errors.productOverview?.manufactureLeadTime[0]}</p>
                            )}
                        </label>
                    </div>

                    <MediaCard
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        values={values}
                        touched={touched}
                        errors={errors}
                        handleImageChange={handleImageChange}
                        handleRemove={handleRemove}
                        setFieldValue={setFieldValue}
                    />

                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Inventory</h2>
                        <div style={{ display: "flex", gap: "14px" }}>

                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                SKU
                                <input
                                    type="text"
                                    name="inventory.sku"
                                    placeholder="Enter"
                                    className={styles.addCatInput}
                                    value={values.inventory.sku}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.inventory?.sku && touched.inventory?.sku && (
                                    <p className={styles.errorText}>{errors.inventory?.sku}</p>
                                )}
                            </label>
                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                Stock
                                <input
                                    type="number"
                                    name="inventory.qtyAvailable"
                                    placeholder="Enter"
                                    className={styles.addCatInput}
                                    value={values.inventory.qtyAvailable}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.inventory?.qtyAvailable && touched.inventory?.qtyAvailable && (
                                    <p className={styles.errorText}>{errors.inventory?.qtyAvailable}</p>
                                )}
                            </label>
                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                Short Lead Time
                                <input
                                    type="text"
                                    name="inventory.shortLeadTime"
                                    placeholder="Enter"
                                    className={styles.addCatInput}
                                    value={values.inventory.shortLeadTime}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </label>
                        </div>
                        <div style={{ display: "flex", gap: "14px" }}>


                            <label className={styles.addCatLabel} style={{ width: "33%" }}>
                                minimumMultiplier
                                <input
                                    type="text"
                                    name="inventory.minimumMultiplier"
                                    placeholder="Enter"
                                    className={styles.addCatInput}
                                    value={values.inventory.minimumMultiplier}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.inventory?.minimumMultiplier && touched.inventory?.minimumMultiplier && (
                                    <p className={styles.errorText}>{errors.inventory?.minimumMultiplier}</p>
                                )}
                            </label>
                        </div>
                    </div>

                    <PricingCard
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        values={values}
                        touched={touched}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />


                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Additional Resources</h2>
                        <div style={{ display: "flex", gap: "14px" }}>

                            <label className={styles.addCatLabel} style={{ width: "50%" }}>
                                HSN Code
                                <input
                                    type="text"
                                    name="additionalResources.HSN Code[0]"
                                    placeholder="Enter"
                                    className={styles.addCatInput}
                                    value={values.additionalResources?.["HSN Code"]?.[0]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.inventory?.sku && touched.inventory?.sku && (
                                    <p className={styles.errorText}>{errors.inventory?.sku}</p>
                                )}
                            </label>
                            <label className={styles.addCatLabel} style={{ width: "50%" }}>
                                Standard Packaging Quantity
                                <input
                                    type="text"
                                    name="additionalResources.Standard_Packaging_Quantity[0]"
                                    placeholder="Enter"
                                    className={styles.addCatInput}
                                    value={values.additionalResources?.Standard_Packaging_Quantity?.[0]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </label>
                        </div>

                    </div>

                    <VariantsCard
                        values={values}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        handleChange={handleChange}
                        errors={errors}
                        touched={touched}
                    />


                    <div className={styles.buttonGroup}>
                        <button
                            type="button"
                            className={styles.cancelButton}
                            onClick={() => navigate(from === "edit" ? "/products/allProduct" : -1, { replace: from === "edit" })}
                        >
                            <Close />
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={styles.updateButton}
                            disabled={formLoading}
                            onClick={handleSubmit}
                        >
                            {formLoading ? "please wait..." : from == "add" ? "Add Product" : "Edit Product"}
                        </button>
                    </div>
                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Category</h2>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Product Category
                            <SearchableSelect
                                name="categories[0]"
                                value={values.categories[0]}
                                options={categories}
                                onChange={handleCategoryChange}
                                onBlur={handleBlur}
                                placeholder="Select..."
                                searchPlaceholder="Search Category..."
                                hasError={Boolean(touched.categories?.[0] && errors.categories?.[0])}
                            />
                            {touched.categories?.[0] && errors.categories?.[0] && (
                                <div className={styles.errorText}>{errors.categories}</div>
                            )}
                        </label>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Product Sub-Category
                            <SearchableSelect
                                name="categories[1]"
                                value={values.categories[1]}
                                options={filteredSubcategory}
                                onChange={handleCategoryChange}
                                onBlur={handleBlur}
                                placeholder="Select..."
                                searchPlaceholder="Search Sub-Category..."
                                hasError={Boolean(touched.categories?.[1] && errors.categories?.[1])}
                            />
                            {touched.categories?.[1] && errors.categories?.[1] && (
                                <div className={styles.errorText}>{errors.categories}</div>
                            )}
                        </label>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Level 3
                            <SearchableSelect
                                name="categories[2]"
                                value={values.categories[2]}
                                options={filteredLevel3}
                                onChange={handleCategoryChange}
                                onBlur={handleBlur}
                                placeholder="Select..."
                                searchPlaceholder="Search Level 3..."
                            />
                        </label>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Manufacturer
                            <SearchableSelect
                                name="productOverview.manufacturer[0]"
                                value={values.productOverview.manufacturer[0]}
                                options={combinedManufacturers}
                                onChange={(e) => {
                                    handleChange(e);
                                    const selectedMfgId = e.target.value;
                                    if (selectedMfgId && combinedManufacturers?.length) {
                                        const selectedMfg = combinedManufacturers.find(m => m?._id?.toString() === selectedMfgId?.toString() || m?.name?.trim()?.toLowerCase() === selectedMfgId?.toString()?.toLowerCase());
                                        const mfgName = selectedMfg?.name;
                                        if (mfgName) {
                                            const currentAttrs = { ...(values.attributes || {}) };
                                            const mfgKey = Object.keys(currentAttrs).find(k => k.trim().toLowerCase() === "manufacturer") || "Manufacturer";
                                            currentAttrs[mfgKey] = [mfgName];
                                            setFieldValue("attributes", currentAttrs);
                                        }
                                    }
                                }}
                                onBlur={handleBlur}
                                placeholder="Select..."
                                searchPlaceholder="Search Manufacturer..."
                                hasError={Boolean(errors.productOverview?.manufacturer?.[0] && touched.productOverview?.manufacturer?.[0])}
                            />
                            {errors.productOverview?.manufacturer?.[0] && touched.productOverview?.manufacturer?.[0] && (
                                <p className={styles.errorText}>{errors.productOverview?.manufacturer[0]}</p>
                            )}
                        </label>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Featured image</h2>
                        <p
                            style={{
                                fontSize: "13px",
                                color: "#777980",
                                padding: "10px 0px 4px 0px",
                            }}
                        >
                            Photo
                        </p>
                        {loading ? (
                            <div className={styles.uploadBox} style={{ padding: "12px" }}>please wait...</div>
                        ) : (
                            <>
                                {values.assets.featuredImage[0] ? (
                                    <div
                                        className={styles.uploadBox}
                                        style={{ display: "flex", justifyContent: "center", padding: "12px" }}
                                    >
                                        <img
                                            src={values.assets.featuredImage[0]}
                                            alt=""
                                            className={styles.previewImage}
                                        />
                                        <div
                                            className={styles.cancel_cross}
                                            onClick={() => handleRemove("assets.featuredImage[0]")}
                                        >
                                            {closeCircle()}
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className={styles.uploadBox}
                                        onClick={() => thumbnailImageref.current.click()}
                                        onDrop={(e) => {
                                            e.preventDefault();
                                            handleImageChange(e, "assets.featuredImage[0]", "assets.featuredImage[0]");
                                        }}
                                        onDragOver={(e) => e.preventDefault()}
                                        style={{ cursor: "pointer", padding: "14px 16px" }}
                                    >
                                        <span className={styles.uploadIcon} style={{ marginBottom: "4px" }}>
                                            <UploadImg />
                                        </span>
                                        <p className={styles.addCatPara} style={{ fontSize: "13px", marginBottom: "8px" }}>
                                            Drag and drop image here, or click add image
                                        </p>
                                        <button type="button" className={styles.addImgBtn} style={{ padding: "6px 14px", fontSize: "13px" }}>
                                            Add Image
                                        </button>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            ref={thumbnailImageref}
                                            style={{ display: "none" }}
                                            name="assets.featuredImage[0]"
                                            onChange={(e) =>
                                                handleImageChange(e, "assets.featuredImage[0]", "assets.featuredImage[0]")
                                            }
                                            value={values.assets.featuredImage[0]}
                                        />
                                    </div>
                                )}

                                <div className={styles.urlInputContainer} style={{ marginTop: "8px" }}>
                                    <input
                                        type="text"
                                        placeholder="Enter image URL"
                                        className={styles.urlInput}
                                        value={featuredUrlInput}
                                        onChange={(e) => setFeaturedUrlInput(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleAddFeaturedUrl();
                                            }
                                        }}
                                    />
                                    <button type="button" className={styles.urlAddBtn} onClick={handleAddFeaturedUrl}>
                                        Add URL
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                    <div className={styles.card} style={{ marginTop: "20px" }}>
                        <h2 className={styles.addCatH2}>Alternate/exact match</h2>
                        <div style={{ paddingBottom: '10px', display: "block", marginTop: 10 }} className={styles.addCatLabel}>
                            Select
                            <div style={{ position: 'relative' }} ref={dropdownRef}>

                                <div
                                    className={styles.addCatSelect}
                                    onClick={handleToggleDropdown}
                                >
                                    Select

                                </div>

                                {
                                    isOpen &&
                                    <div className={styles.dropdownContents}>
                                        <div style={{}}>
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    boxSizing: 'border-box',
                                                    border: '1px solid #ccc',
                                                    borderRadius: '4px'
                                                }}
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                            />
                                        </div>
                                        <div style={{ maxHeight: "140px", overflowY: "scroll" }}>
                                            {(filteredData || productsdrop)?.map((customer) => (
                                                <label
                                                    key={customer?._id}
                                                    className={styles.dropdownItems}
                                                >
                                                    {customer?.productNumber}
                                                    <input
                                                        type="checkbox"
                                                        checked={values?.customer?.includes(customer?.productNumber)}
                                                        onChange={() => handleSelectionChange(customer?.productNumber)}
                                                    />
                                                </label>
                                            ))}


                                        </div>
                                        <div style={{ display: 'flex', justifyContent: "center", width: "100%" }}>
                                            <button
                                                // type="submit"
                                                className={styles.loginButton}
                                                style={{ borderRadius: "0px" }}
                                                onClick={() => setIsOpen(false)}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                }

                            </div>
                            {values?.alternateProducts?.map((i) => {
                                const manufacturer = productsdrop?.find((item) => item.productNumber === i);
                                return (
                                    <div className={styles.dropdownresult}>
                                        {manufacturer?.productNumber} <div onClick={() => handleSelectionChange(manufacturer.productNumber)}><Closecircle /></div>
                                    </div>
                                )
                            })

                            }

                        </div>
                    </div>

                    <div className={styles.card} style={{ marginTop: "20px" }}>
                        <h2 className={styles.addCatH2}>RoHS</h2>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            RoHS
                            <select
                                name="RoHS"
                                className={styles.addCatSelect}
                                onChange={(e) => {
                                    setFieldValue("RoHS", [e.target.value]);
                                }}
                                onBlur={handleBlur}
                                value={Array.isArray(values.RoHS) ? values.RoHS[0] : values.RoHS || "YES"}
                            >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                            {touched?.RoHS && errors?.RoHS && (
                                <div className={styles.errorText}>{errors?.RoHS}</div>
                            )}
                        </label>
                    </div>

                    <div className={styles.card} style={{ marginTop: "20px" }}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label style={{ marginTop: "16px", display: "block" }}>
                            Product Status
                            <select
                                name="status"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.status || "PUBLISHED"}
                            >
                                {
                                    status?.map((i, index) => (
                                        <option key={index} value={i}>{i}</option>
                                    ))
                                }
                            </select>
                            {touched?.status && errors?.status && (
                                <div className={styles.errorText}>{errors?.status}</div>
                            )}
                        </label>
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddProductForm;
